<template>
    <div>
        <limits-editable-table
            v-if="limitsRequired"
            v-model="form.limits.items"
            :total-cost="supplementaryAgreement.price"
            @validate="limitsValidate"
            :limit-year="purchase.purchase_terms.purchase_limit_year"
            :order-type="purchase.purchase_terms.order_type"
            purchase-type="fl44_unknown_volume"
            :purchase-id="purchase.id">
            <template #title>
                <h5 class="grey-color ml-1 mt-3 mb-1 main_text font-weight-bold">Измените лимиты</h5>
            </template>
            <template #label-hint> Добавьте или измените лимиты. Необходимо полностью распределить стоимость дополнительного соглашения по соответствующим лимитам. </template>
            <template #label-total> Стоимость дополнительного соглашения, руб.: </template>
            <template #label-variance> Отклонение от стоимости дополнительного соглашения, руб.: </template>
        </limits-editable-table>
        <form-row-edit-supplier-accounting v-if="limitsRequired" v-model="form.supplier_accounting" @validate="supplierAccountingValidate">
            <template #title>
                <h5 class="ml-1 mt-3 mb-1 main_text font-weight-bold">Банковские реквизиты поставщика</h5>
            </template>
            <template #info>
                <div class="ml-1 fs-14">Укажите банковские реквизиты поставщика для заключения контракта, которые будут переданы в РИС после заключения.</div>
            </template>
        </form-row-edit-supplier-accounting>
        <b-row>
            <b-col>
                <fl44-unknown-volume-customer-sign-supplementary-agreement-button class="mr-2 mb-2" :purchase="purchase" :is-available="!$v.$invalid" :form="form" @refresh="$emit('refresh')" :supplementary-agreement="supplementaryAgreement" />
                <fl44-unknown-volume-customer-sign-decline-supplementary-agreement-button class="mb-2" :purchase="purchase" :supplementary-agreement="supplementaryAgreement" @refresh="$emit('refresh')" />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators';

import Config from '@/rearchitected/core/js/ddriven/application/config/Config';
import cloneDeep from 'lodash.clonedeep';
import Fl44UnknownVolumeCustomerSignSupplementaryAgreementButton from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-customer-sign-supplementary-agreement-button.vue';
import Fl44UnknownVolumeCustomerSignDeclineSupplementaryAgreementButton from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-customer-sign-decline-supplementary-agreement-button.vue';

export default {
    name: 'private-fl44-unknown-volume-supplementary-agreement-sign-form-customer',
    components: { Fl44UnknownVolumeCustomerSignDeclineSupplementaryAgreementButton, Fl44UnknownVolumeCustomerSignSupplementaryAgreementButton },
    props: {
        purchase: {
            type: Object,
            required: true
        },
        supplementaryAgreement: {
            type: Object,
            required: true
        }
    },
    mounted() {
        this.form.limits.items = cloneDeep(this.supplementaryAgreement.limits);
        this.form.supplier_accounting = cloneDeep(this.supplementaryAgreement.supplier_accounting);
    },
    data() {
        return {
            isDataSending: false,
            form: {
                limits: {
                    items: []
                },
                supplier_accounting: {
                    bank_type: 'bank',
                    bik: null,
                    bank_name: null,
                    bank_city: null,
                    ks: null,
                    rs: null,
                    ls: null,
                    fo_inn: null,
                    fo_name: null
                }
            },
            isLimitsValid: false,
            isSupplierAccountingValid: false
        };
    },
    validations() {
        return {
            form: {
                limits: {
                    isLimitsValid() {
                        return !this.limitsRequired || this.isLimitsValid;
                    }
                },
                supplier_accounting: {
                    required: requiredIf(() => this.limitsRequired),
                    isSupplierAccountingValid() {
                        return !this.limitsRequired || this.isSupplierAccountingValid;
                    }
                }
            }
        };
    },
    methods: {
        limitsValidate(value) {
            this.isLimitsValid = !value;
        },
        supplierAccountingValidate(value) {
            this.isSupplierAccountingValid = !value;
        }
    },
    computed: {
        Config() {
            return Config;
        },
        limitsRequired() {
            return this.features.kbk_limits && !this.purchase.purchase_terms.without_limits;
        },
        features() {
            return Config.get('theme.features');
        }
    }
};
</script>
